require('./bootstrap');

require('lightgallery');

require('select2');

// Site-wide functions, animations, etc.
import HDTrade from './site-ui';

// Alert handling
require('./site-alert');

$(document).ready(function() {
    HDTrade.init();
});
